export enum ReportPages {
  GiftCardReport = "/reports/giftcard",
}
